export default __webpack_public_path__ + "static/media/3_long.c2db775e.svg";